import { Info, AlertCircle, CheckCircle, AlertTriangle } from 'lucide-react';

interface CalloutBoxProps {
  type?: 'info' | 'warning' | 'success' | 'error';
  title?: string;
  children: React.ReactNode;
}

export function CalloutBox({ type = 'info', title, children }: CalloutBoxProps) {
  const styles = {
    info: {
      bg: 'bg-[#34AFFB]/10',
      border: 'border-[#34AFFB]/30',
      text: 'text-[#34AFFB]',
      icon: Info,
    },
    warning: {
      bg: 'bg-amber-50',
      border: 'border-amber-200',
      text: 'text-amber-700',
      icon: AlertTriangle,
    },
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-700',
      icon: CheckCircle,
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      text: 'text-red-700',
      icon: AlertCircle,
    },
  };

  const style = styles[type];
  const Icon = style.icon;

  return (
    <div className={`${style.bg} border ${style.border} rounded-lg p-6 my-6`}>
      <div className="flex gap-3">
        <Icon className={`h-5 w-5 ${style.text} flex-shrink-0 mt-0.5`} />
        <div className="flex-1">
          {title && (
            <h4 className={`font-semibold ${style.text} mb-2`}>{title}</h4>
          )}
          <div className="text-[#4B5563]">{children}</div>
        </div>
      </div>
    </div>
  );
}
